import Vue from 'vue';
import Vuex from 'vuex';
import mutations from './mutations';
import actions from './actions';
import authorize from './modules/authorize';


Vue.use(Vuex);

const state = {
  cityList: [],
  currentCityByIp: null,
  // list页面的url,用于保存list的筛选条件
  saveListPath: '',
  //降级开关，开启就走静态json api
  demotionSwitch: false,
  isShowCredit: true, //!userAgentHelper.isAliMini()所有渠道默认打开
};

const getters = {
  currentCity: stete => {
    let urlShort = location.host.split('.')[0];
    if (urlShort == "h5" && state.currentCityByIp && state.currentCityByIp.domain && state.currentCityByIp.cityName != "定位失败") {
      if (state.currentCityByIp.isOnline == 1) {
        return state.currentCityByIp;
      }
    }
    if (urlShort === 'sh'|| urlShort === 'h5' || urlShort.indexOf('localhost') !== -1) {
      urlShort = 'www';
    }
    return state.cityList.filter(function (data) {
      return data.domain === urlShort;
    })[0] || state.cityList[0] || {};
  }
};

export default new Vuex.Store({
  modules: {
    authorize
  },
  state,
  actions,
  getters,
  mutations
});



// WEBPACK FOOTER //
// ./src/store/index.js